import React, { Component } from 'react'
import {
  Container,
  Message,
  Segment
} from 'semantic-ui-react'
 
class NotFound extends Component {

    render() {
        return(
            <div>
                <Segment textAlign='center' style={{  minHeight: 700, padding: '4em 0em' }} vertical>
                    <Container textAlign='left' text>
                        <Message error content='Error 404. This page is not found.'/>
                    </Container>
                </Segment>
            </div>
)
    }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/layouts/NotFound.js